import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapShortcutSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcapshortcut: {
      group: 'inline',
      inline: true,
      content: 'text*',
      definingForContent: true,
      parseDOM: [{
        tag: 'MadCap\\:shortcut'
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:shortcut'
    }
  } satisfies Record<string, NodeSpec>;
}
